<template>
  <div class="container-fluid bg-gray-30 rounded mb-4">
    <div class="row py-4">
      <div class="col-12 col-md-6">
        <h6 class="font-weight-normal">{{ __('lang.kwl.project_overviw.configuration_description') }}</h6>
        <p class="text-gray-60 border-gray-50 border-bottom pb-2">
          <input v-model="description" class="form-control" name="formfield_1" required @change="storeConfiguration">
        </p>
      </div>
      <div class="col-12 col-md-6">
        <h6 class="font-weight-normal">{{ __('lang.kwl.project_overviw.editor') }}</h6>
        <p class="text-gray-60 border-gray-50 border-bottom pb-2">
          <input v-model="editor" class="form-control" name="formfield_2" @change="storeConfiguration">
        </p>
      </div>
      <div class="col-12 col-md-6">
        <h6 class="font-weight-normal mb-3">{{ __('lang.kwl.project_overviw.project') }}</h6>
        <p v-if="name != ''" class="text-gray-60 border-gray-50 border-bottom pb-2">{{ name }}</p>
        <p v-else class="text-gray-60 border-gray-50 border-bottom pb-2">{{
            __('lang.kwl.project_overviw.not_set')
          }}</p>
      </div>
      <div class="col-12 col-md-6">
        <h6 class="font-weight-normal">{{ __('lang.kwl.project_overviw.norm') }}</h6>
        <p class="text-gray-60 border-gray-50 border-bottom pb-2">
          <b-form-select v-model="norms_id" :options="normOptions" class="form-control" size="sm"
                         @change="changeNorms"></b-form-select>
        </p>
      </div>
      <div class="col-12 py-3 text-center">
        <button class="btn btn-primary" @click="openModal()">{{ __('lang.kwl.project_overviw.adjust_values') }}</button>
      </div>
    </div>
  </div>
</template>
<script>
import Project from '@models/project/Project';
import Configuration from '@models/project/Configuration';
import pageValidation from '@services/validations/pageValidation'
import {clearSessionForNorm} from '@services/helpers/sessionHandler'


export default {
  data() {
    return {
      description: '',
      editor: '',
      name: '',
      norms_id: 1,

      normOptions: [],
    }
  },
  methods: {
    clearSessionForNorm: clearSessionForNorm,

    setData() {
      this.normOptions = [];
      this.norms.forEach(norm => {
        this.normOptions.push({"value": norm.id, "text": this.__(norm.norm)})
      })
      if (this.configuration != null) {
        this.description = this.configuration.description
        this.editor = this.configuration.editor
        this.norms_id = this.configuration.norms_id
        if (this.configuration.project != null) {
          this.name = this.configuration.project.name
        } else {
          this.name = ''
        }
      }
    },

    changeNorms() {
      clearSessionForNorm(true);
      this.storeConfiguration();
    },

    storeConfiguration() {
      if (this.configuration != null) {
        Configuration.update({
          where: this.configuration.id,
          data: {
            description: this.description,
            editor: this.editor,
            norms_id: this.norms_id
          }
        })
      } else {
        Project.insert({
          data: {
            selectedProject: true,
            contact: [{
              type: 1
            }],
            configurations: [{
              description: this.description,
              editor: this.editor,
              norms_id: this.norms_id,
              selectedConfiguration: true
            }]
          },
          create: ['configurations']
        });
      }
      pageValidation.validatePossiblePages();
    },
    openModal() {
      this.$store.dispatch('modalSettings/setComponent', 'SaveConfiguration');
      this.$store.dispatch('modalSettings/isLarge', false);
      this.$store.dispatch('modalSettings/callRef', {type: 0});
      this.$store.dispatch('modalSettings/open');
    },
  },
  computed: {
    configuration() {
      return Configuration.query().with(['project']).first();
    },

    norms: {
      get() {
        return this.$store.state.session.norms
      },
    },

  },
  created() {
    this.setData();

  },
  watch: {
    configuration: {
      handler(newValue) {
        if (newValue != null) this.setData();
      },
    }
  }
}
</script>
